// WP-07 — React Query wiring (LLD-05 §2.4/§7): server state lives here, never
// in Zustand. Retry policy per §7 Resilience: idempotent GETs retry with
// backoff on technical failure only; mutations retry ONLY on 5xx/network
// (UnexpectedError), NEVER on 4xx (BusinessError).
import { QueryClient } from "@tanstack/react-query";
import { UnexpectedError } from "../api/errors";

function retryOnUnexpectedOnly(failureCount: number, error: unknown): boolean {
  return error instanceof UnexpectedError && failureCount < 2;
}

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: retryOnUnexpectedOnly,
        staleTime: 15_000, // near-live job cards baseline (US 1.2, §7)
        refetchOnWindowFocus: true,
      },
      mutations: {
        retry: retryOnUnexpectedOnly,
      },
    },
  });
}
